import { useState } from 'react';
import { NoddiPaginationState } from '../../../../types/pagination';
import { DEFAULT_PAGE_SIZE } from './paginationDefaults';

interface Params {
  initialPage?: number;
  initialPageSize?: number;
  initialSearch?: string;
}

export function usePagination(params?: Params) {
  const { initialPage = 0, initialPageSize = DEFAULT_PAGE_SIZE, initialSearch = '' } = params ?? {};

  const [pageIndex, setPageIndex] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [search, setSearch] = useState(initialSearch);

  // Custom pageSize setter that also resets page to initial value
  const handleSetPageSize = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPageIndex(initialPage);
  };

  // Custom search setter that also resets page to initial value
  const handleSetSearch = (newSearch: string) => {
    setSearch(newSearch);
    setPageIndex(initialPage);
  };

  const setPagination = (pagination: NoddiPaginationState) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setSearch(pagination.search);
  };

  return {
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize: handleSetPageSize,
    search,
    setSearch: handleSetSearch,
    pagination: { pageIndex, pageSize, search },
    setPagination
  };
}
